// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"583":"1bad8b30","859":"220368eb"}[chunkId] + ".chunk.css";
};